export interface SegmentClickEventProps {
  type: string
  clickUrl?: string
  clickText?: string
  location?: string
  imageName?: string
  userId?: string
}

interface SegmentPlaybackEventProps {
  type: string
  videoTitle: string
  percentage: number
}

interface SegmentFormSubmitEventProps {
  formId: string
  clickText?: string
}

interface SegmentPageScrollDepthEventProps {
  url: string
  scrollDepth: string
}

export const trackClickForSegmentAnalytics = ({
  clickText,
  clickUrl,
  imageName,
  location,
  type,
  userId
}: SegmentClickEventProps) => {
  if (window.analytics) {
    const signUpIntentEvent = clickUrl && clickUrl.includes('/register')
    window.analytics.track(signUpIntentEvent ? 'Sign Up Intent' : `Call To Action ${type} Clicked`, {
      ...(clickUrl && { click_url: clickUrl }),
      ...(clickText && { click_text: clickText }),
      ...(location && { location }),
      ...(imageName && { image_name: imageName }),
      ...(userId && { user_id: userId })
    })
  }
}
export const trackPlaybackForSegmentAnalytics = ({ percentage, type, videoTitle }: SegmentPlaybackEventProps) => {
  if (window.analytics) {
    window.analytics.track(`Video Playback ${type}`, {
      object: 'Video',
      percentage: percentage,
      title: videoTitle
    })
  }
}

export const trackFormSubmitForSegmentAnalytics = ({ clickText = 'Submit', formId }: SegmentFormSubmitEventProps) => {
  if (window.analytics) {
    window.analytics.track('Form Submitted', {
      click_text: clickText,
      form_id: formId,
      object: 'Form'
    })
  }
}

export const trackPageScrollDepthForSegmentAnalytics = ({ scrollDepth, url }: SegmentPageScrollDepthEventProps) => {
  if (window.analytics) {
    window.analytics.track('Page Scroll Depth', {
      scroll_depth: scrollDepth,
      url
    })
  }
}
